/* eslint-disable no-unused-vars */
import { $http } from '@/utils/http'
import host from '@/utils/host'
import { report } from '@/utils/reportError'
import { hasNeedLoginKeyWords } from '@/utils/handleError'
import { openLink } from '@/utils/utils'
import moment from 'moment'
export default {
  namespaced: true,
  state: {
    expiresTime: '', // 过期时间 
    brandBusinessInfo: {} // 品牌商业务信息
  },
  mutations: {
    setMutation(state, { data, namespace }) {
      state[namespace] = data
    },
    setExpiresTime(state, data) {
      state.expiresTime = data
    },
    setBrandBusinessInfo(state, data) {
      state.brandBusinessInfo = data
    }
  },
  actions: {
    async getKeyExpiresTime({ commit }, params) {
      const res = await $http.get(`${host.portal}/portal-api/user/getAppkeyExpiresTime.do`)
      commit('setExpiresTime', res.data.expiresTime ? (moment().unix() * 1000 >  res.data.expiresTime ? 'AppKey已过期，请及时更新' :`AppKey有效期至:${moment(res.data.expiresTime).format('YYYY.MM.DD')}` ): '' )
      return res
  },
    async getCategoryQQ() {
      const url = `${host.scm}/partners-scm-web/index/getCategoryQQ.do`
      const res = await $http.get(url)
      if (res && res instanceof Array) {
        return res
      } else if (hasNeedLoginKeyWords(res)) {
        return report({
          url,
          res,
          msg: '去登陆'
        })
      } else {
        !res.report && report({
          url,
          res,
          msg: res.msg || '品牌商工作台获取财务QQ接口异常'
        })
        return []
      }
    },
    async queryRealTimeOverview() {
      const url = `${host.dataadvice}/k-dataadvice/advicePCGoods/realTimeOverview.do`
      return await $http.get(url)
    },
    async queryRankData({commit}, orderType) {
      const url = `${host.dataadvice}/k-dataadvice/advicePCGoods/homepageRankData.do?orderType=${orderType}`
      return await $http.get(url)
    },
    async downloadRankData({commit}, orderType) {
      const url = `${host.dataadvice}/k-dataadvice/advicePCGoods/homepageRankDataDown.do?orderType=${orderType}`
      openLink(url, true)
    },
    async queryBrandBusinessInfo({commit}) {
      const url = `${host.hbpsproxyapi}/hbp-sproxy-api/kwbsapi/o/business/queryBrandBusinessInfoForWorkbench.do`
      const res = await $http.get(url)
      if (res && res.code * 1 === 1 && res.data) {
        commit('setBrandBusinessInfo', res.data)
      }
      return res
    }
  }
}
